module.exports = __webpack_public_path__ + "img/mock-ui.a386fd.png";